import React, { useState } from 'react'
import { useQueryParam } from '../shared/hooks/location'
import { useApiFormAuthProvider } from '../api-new/state/auth'
import { useLoad } from '../shared/hooks/load'
import { OpenAccountConsent } from './open-account-consent'
import { SignInLinkFailed, SignInLinkSpent, useSignInLinkSpent } from '../shared/sso-workspace/sign-in-link-spent'
import { sendToLinkConfirmation } from '../shared/sso-workspace/link-confirm-api'

// /open/register?token=…: the first sign-in through a single sign-on connection.
// The page itself is open-account-consent.js; this owns the calls:
// GET auth-provider/:token/details for who and which connection,
// GET auth-provider/:token/register on accept, then /open/organization.
// A register auth holds for link confirmation (the email has an account
// now: 403 link_confirmation_required) goes to /open/link for the token.
export const OpenRegister = () => {
  const token = useQueryParam('token')

  const [error, updateError] = useState()

  const apiFormAuthProvider = useApiFormAuthProvider()
  const apiFormAuthProviderDetails = useApiFormAuthProvider()

  // A link already used or expired: the calm card (sign-in-link-spent.js).
  const [spent, onSpent] = useSignInLinkSpent()
  // The link's first call failed otherwise: the "didn't work" card (owner 2026-10-17).
  const [failed, updateFailed] = useState(null)

  useLoad(async () => {
    try {
      await apiFormAuthProviderDetails.get(`${token}/details`)
    } catch (error) {
      if (!onSpent(error)) updateFailed(error || {})
    }
  }, [])

  const handleSubmit = async () => {
    try {
      await apiFormAuthProvider.get(`${token}/register`)

      let url = new URL(`${process.env.REACT_APP_SITE}/open/organization`)
      url.searchParams.set('token', token)
      // replace: Back must not return to this step's spent token.
      window.location.replace(url.href)
    } catch (error) {
      if (onSpent(error)) return
      if (sendToLinkConfirmation(error, token)) return
      updateError(error && error.data)
    }
  }

  // The details response carries redirectCancelURL on its form; the old page
  // read it off the hook itself, where it is never set.
  const handleCancel = async () =>
    (window.location = apiFormAuthProviderDetails.form.redirectCancelURL || apiFormAuthProviderDetails.redirectCancelURL)

  if (spent) {
    return <SignInLinkSpent reason={spent} />
  }

  if (failed) {
    return <SignInLinkFailed error={failed} />
  }

  return <OpenAccountConsent mode="register" details={apiFormAuthProviderDetails} error={error} onSubmit={handleSubmit} onCancel={handleCancel} />
}
